import { render, staticRenderFns } from "./deal-user.vue?vue&type=template&id=4a1f9e03&scoped=true&"
import script from "./deal-user.vue?vue&type=script&lang=js&"
export * from "./deal-user.vue?vue&type=script&lang=js&"
import style0 from "./deal-user.vue?vue&type=style&index=0&id=4a1f9e03&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1f9e03",
  null
  
)

export default component.exports